import { VhvButton, VhvDialog } from "@vhv/ui-kit-react";
import { MessageHelper } from "../../helpers/MessageHelper";
import styles from "./credential.module.scss";
import React, { useRef } from "react";
import LightweightLabel from "../../components/label/LightweightLabel";
const { Color } = require("@vhv/ui-kit/dist/collection/utils/utils");
export const WebauthnRegistrationDialog = (props) => {
    const { showWebauthnRegistrationDialog, credDisplayName, updatePasswordAction, setupAction, hasTokens } = props;
    const dialogRef = useRef(null);
    const renderSetUpPasswordSection = () => {
        if (!showWebauthnRegistrationDialog && updatePasswordAction) {
            return React.createElement(React.Fragment, null,
                React.createElement(LightweightLabel, { className: styles.dialogLabel },
                    React.createElement("div", { slot: "content" },
                        React.createElement(MessageHelper, { msgKey: "webauthnPasswordRequiredHint" }))),
                React.createElement("section", { className: styles.actionButtonSection },
                    React.createElement(VhvButton, { className: styles.actionButton, onClick: () => updatePasswordAction.execute(), "aria-label": "new-password-button" },
                        React.createElement(MessageHelper, { msgKey: "setUpNewPassword" })),
                    React.createElement(VhvButton, { className: styles.actionButton, onClick: () => { var _a; return (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.hide(); }, color: Color.SECONDARY },
                        React.createElement(MessageHelper, { msgKey: "cancel" }))));
        }
        return null;
    };
    const renderSetUpSecurityTokenSection = () => {
        if (showWebauthnRegistrationDialog || !updatePasswordAction) {
            return React.createElement(React.Fragment, null,
                React.createElement(LightweightLabel, { className: styles.dialogLabel },
                    React.createElement("div", { slot: "content" },
                        React.createElement(MessageHelper, { msgKey: "webauthnRegistrationHint" }))),
                React.createElement("section", { className: styles.actionButtonSection },
                    React.createElement(VhvButton, { className: styles.actionButton, onClick: () => setupAction.execute(), "aria-label": "new-key-button" },
                        React.createElement(MessageHelper, { msgKey: "setUpNew", params: [credDisplayName] })),
                    React.createElement(VhvButton, { className: styles.actionButton, onClick: () => { var _a; return (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.hide(); }, color: Color.SECONDARY },
                        React.createElement(MessageHelper, { msgKey: "cancel" }))));
        }
        return null;
    };
    return React.createElement("div", null,
        React.createElement(VhvButton, { onClick: () => dialogRef.current.show(), "aria-label": "set-up-button" },
            React.createElement(MessageHelper, { msgKey: hasTokens ? "addAdditionalFidoToken" : "addFidoToken" })),
        React.createElement(VhvDialog, { ref: dialogRef, closable: true, "content-center-width": "m", hidden: !showWebauthnRegistrationDialog, role: "dialog" },
            React.createElement("div", { className: styles.webauthnRegistrationDialog },
                renderSetUpPasswordSection(),
                renderSetUpSecurityTokenSection())));
};
